import type { CreateNotificationInput, Maybe } from "../../../../graphql/types";
import type {
  RawNotification,
  AppNotification,
  NotificationCategory,
  NotificationFormValues,
} from "./notificationTypes";

function filterNullable<T>(
  arr: Maybe<Array<Maybe<T>>> | undefined,
): NonNullable<T>[] {
  if (!arr) return [];
  return arr.reduce<NonNullable<T>[]>((acc, v) => {
    if (v != null) acc.push(v);
    return acc;
  }, []);
}

export function toAppNotification(raw: RawNotification): AppNotification {
  return {
    id: String(raw.id),
    title: String(raw.title),
    message: String(raw.message),
    category: (raw.notificationType as NotificationCategory) ?? "Notification",
    publishAt: new Date(raw.startDateTime as unknown as string),
    expiresAt: raw.expireDateTime
      ? new Date(raw.expireDateTime as unknown as string)
      : undefined,
    active: raw.active === true,
    isWelcome: raw.isWelcome === true,
    targetGroups: filterNullable(raw.targetGroups),
    attachmentKeys: filterNullable(raw.attachementKeys),
  };
}

export function toCreateNotificationInput(
  values: NotificationFormValues,
): CreateNotificationInput {
  return {
    title: values.title,
    message: values.message,
    notificationType: values.category,
    startDateTime: new Date(values.publishAt).toISOString() as unknown as Date,
    expireDateTime: values.expiresAt
      ? (new Date(values.expiresAt).toISOString() as unknown as Date)
      : undefined,
    active: values.active,
    isWelcome: values.isWelcome,
    targetGroups: values.groups,
    attachementKeys: values.attachmentKeys,
  };
}
